export default __webpack_public_path__ + "static/media/PropertyDev_Shapes-04.89cbe543.png";